export interface Department {
  name: string;
  activationCode: string;
}

export interface BusinessConfig {
  id: number;
  name: string;
  subdomain: string;
  departments: Department[];
}

export const businesses: BusinessConfig[] = [
  {
    id: 12,
    name: 'Teck Quebrada Blanca',
    subdomain: 'qb',
    departments: [
      { name: 'Default', activationCode: 'TC-D3D' },
      { name: 'Operación Mina', activationCode: 'TC-OB7' },
      { name: 'Planta', activationCode: 'TC-PB8' },
      { name: 'Administrativo', activationCode: 'TC-AB9' },
      { name: 'Otro', activationCode: 'TC-OBA' },
    ],
  },
  {
    id: 13,
    name: 'Otros Quebrada Blanca',
    subdomain: 'qb',
    departments: [{ name: 'Default', activationCode: 'OD-D3E' }],
  },
  {
    id: 35,
    name: 'Multi X - Chaparano',
    subdomain: 'multix',
    departments: [
      { name: '[CC] Administración', activationCode: 'M23-[EA' },
      { name: '[CC] Operarios Producción', activationCode: 'M23-[ED' },
      { name: '[CC] Técnico en Mantención', activationCode: 'M23-[EF' },
      { name: '[CC] Auxiliar Cocina', activationCode: 'M23-[EB' },
      { name: '[CC] Información Mensual', activationCode: 'M23-[EC' },
      { name: '[CC] Otros', activationCode: 'M23-[EE' },
    ],
  },
  {
    id: 6,
    name: 'Ultraport - Arica',
    subdomain: 'ultraport',
    departments: [
      { name: '[CC] Administrativo', activationCode: 'U6-[23' },
      { name: '[CC] Documental', activationCode: 'U6-[25' },
      { name: '[CC] Mecánico', activationCode: 'U6-[27' },
      { name: '[CC] Movilizador', activationCode: 'U6-[28' },
      { name: '[CC] Operador', activationCode: 'U6-[29' },
      { name: '[CC] Coordinación', activationCode: 'U6-[24' },
      { name: '[CC] Supervisor o Capataz', activationCode: 'U6-[2A' },
      { name: '[CC] General u otros', activationCode: 'U6-[20' },
      { name: 'Mantenimiento', activationCode: 'U6-M17C' },
      { name: 'Supervisores Operaciones', activationCode: 'U6-S17D' },
      { name: 'HSE', activationCode: 'U6-H17E' },
      { name: 'Bodega', activationCode: 'U6-B17F' },
    ],
  },
  {
    id: 1,
    name: 'Makana SPA',
    subdomain: 'register',
    departments: [{ name: 'Demo', activationCode: 'M1-D2C' }],
  },
  {
    id: 11,
    name: 'Aramark Quebrada Blanca',
    subdomain: 'qb',
    departments: [
      { name: 'Default', activationCode: 'AB-D3C' },
      { name: '[CC] Otros', activationCode: 'AB-[44' },
      { name: '[CC] Staff', activationCode: 'AB-[43' },
      { name: '[CC] Retail', activationCode: 'AB-[42' },
      { name: '[CC] Mantención menor', activationCode: 'AB-[41' },
      { name: '[CC] Alimentación', activationCode: 'AB-[3F' },
      { name: '[CC] Aseo y Hotelería', activationCode: 'AB-[40' },
    ],
  },
  {
    id: 63,
    name: 'Ultraport - Valparaiso',
    subdomain: 'ultraport',
    departments: [
      { name: 'Administrativo Faena', activationCode: 'U3F-A15C' },
      { name: 'Administrativo Sucursal', activationCode: 'U3F-A15D' },
      { name: 'Auxiliar de Fierro', activationCode: 'U3F-A15E' },
      { name: 'Auxiliar de Fruta', activationCode: 'U3F-A15F' },
      { name: 'Movilizador Fruta', activationCode: 'U3F-M160' },
      { name: 'Movilizador Aforo', activationCode: 'U3F-M161' },
      { name: 'Trincador Fierro', activationCode: 'U3F-T162' },
      { name: 'Trincador a bordo', activationCode: 'U3F-T163' },
      { name: 'Trincador Estación de piña/Muelle', activationCode: 'U3F-T164' },
      { name: 'Operador de grúa pórtico', activationCode: 'U3F-O165' },
      { name: 'Operador de grúa RTG', activationCode: 'U3F-O166' },
      { name: 'Operador de NAVE', activationCode: 'U3F-O167' },
      { name: 'Operador de grúa Gottwald', activationCode: 'U3F-O168' },
      { name: 'Operador de grúa Horquilla', activationCode: 'U3F-O169' },
      { name: 'Operador Portacontenedores', activationCode: 'U3F-O16A' },
      { name: 'Operador Tractocamión', activationCode: 'U3F-O16B' },
      { name: 'Portalonero, Personal de tránsito', activationCode: 'U3F-P16C' },
      { name: 'Uto Gate', activationCode: 'U3F-U16D' },
      { name: 'Encargado Gate', activationCode: 'U3F-E16E' },
      { name: 'Carpintero', activationCode: 'U3F-C16F' },
      { name: 'Internación de información', activationCode: 'U3F-I170' },
      { name: 'Capataz', activationCode: 'U3F-C171' },
      { name: 'Encargado de Faena', activationCode: 'U3F-E172' },
      { name: 'Jefe de Nave', activationCode: 'U3F-J173' },
    ],
  },
  {
    id: 64,
    name: 'Saval',
    subdomain: 'saval',
    departments: [{ name: 'Gerencia RRHH', activationCode: 'S40-G174' }],
  },
  {
    id: 28,
    name: 'Ultraport - Angamos',
    subdomain: 'ultraport',
    departments: [
      { name: '[CC] Supervisor', activationCode: 'U1C-[D5' },
      { name: '[CC] Documental', activationCode: 'U1C-[BD' },
      { name: '[CC] Capataz', activationCode: 'U1C-[BC' },
      { name: '[CC] Movilizador', activationCode: 'U1C-[BE' },
      { name: '[CC] Operador', activationCode: 'U1C-[C0' },
      { name: '[CC] Otros', activationCode: 'U1C-[BB' },
      { name: '[CC] Dirigente', activationCode: 'U1C-[D3' },
      { name: '[CC] Oficinista', activationCode: 'U1C-[D6' },
    ],
  },
  {
    id: 29,
    name: 'Ultraport - Mejillones',
    subdomain: 'ultraport',
    departments: [
      { name: '[CC] Operaciones graneles líquidos', activationCode: 'U1D-[CD' },
      { name: '[CC] Administración', activationCode: 'U1D-[C9' },
      { name: '[CC] Otros', activationCode: 'U1D-[D0' },
      { name: '[CC] Eventuales', activationCode: 'U1D-[CB' },
      { name: '[CC] Mantención', activationCode: 'U1D-[CA' },
      { name: '[CC] Operaciones concentrado', activationCode: 'U1D-[CC' },
      { name: '[CC] Operaciones graneles sólidos', activationCode: 'U1D-[CE' },
      { name: '[CC] Puerto Mejillones', activationCode: 'U1D-[D1' },
    ],
  },
  {
    id: 16,
    name: 'MOWI Chacabuco',
    subdomain: 'mowi',
    departments: [
      { name: 'Otros', activationCode: 'M10-O72' },
      { name: '[CC] Acopio', activationCode: 'M10-[64' },
      { name: '[CC] Eviscerado', activationCode: 'M10-[66' },
      { name: '[CC] HON', activationCode: 'M10-[67' },
      { name: '[CC] Secundaria', activationCode: 'M10-[68' },
      { name: '[CC] Calidad', activationCode: 'M10-[69' },
      { name: '[CC] Mantención', activationCode: 'M10-[6E' },
      { name: '[CC] Administración y otros', activationCode: 'M10-[6F' },
      { name: '[CC] Riles', activationCode: 'M10-[70' },
      { name: '[CC] Frigorífico', activationCode: 'M10-[71' },
      { name: '[CC] Primaria', activationCode: 'M10-[65' },
      { name: '[CC] Bodega', activationCode: 'M10-[74' },
      { name: '[CC] Salud y SSO', activationCode: 'M10-[6A' },
      { name: '[CC] Empaque', activationCode: 'M10-[6B' },
      { name: '[CC] Valor Agregado', activationCode: 'M10-[6C' },
      { name: '[CC] Limpieza y Aseo', activationCode: 'M10-[6D' },
    ],
  },
  {
    id: 8,
    name: 'Humboldt',
    subdomain: 'humboldt',
    departments: [
      { name: '[CC] Administración', activationCode: 'H8-[39' },
      { name: '[CC] Cubierta', activationCode: 'H8-[2E' },
      { name: '[CC] Máquinas', activationCode: 'H8-[32' },
      { name: '[CC] Cámara', activationCode: 'H8-[36' },
      { name: '[CC] Otros', activationCode: 'H8-[F5' },
    ],
  },
  {
    id: 47,
    name: 'AquaChile - Planta Chonchi',
    subdomain: 'aguachirle',
    departments: [
      { name: 'EMPAQUE', activationCode: 'A2F-E102' },
      { name: 'CALIDAD', activationCode: 'A2F-C104' },
      { name: 'MANTENCIÓN', activationCode: 'A2F-M105' },
      { name: 'JEFE TURNO', activationCode: 'A2F-J10B' },
      { name: 'HIGENE', activationCode: 'A2F-H10C' },
      { name: '[CC] Default', activationCode: 'A2F-[FD' },
      { name: 'HG', activationCode: 'A2F-H100' },
      { name: 'CONTROL PRODUCCION', activationCode: 'A2F-C103' },
      { name: 'FRIGORIFICO', activationCode: 'A2F-F108' },
      { name: 'YAL', activationCode: 'A2F-Y10A' },
      { name: 'FILETE', activationCode: 'A2F-F101' },
      { name: 'ACOPIO', activationCode: 'A2F-A106' },
      { name: 'PATIO', activationCode: 'A2F-P107' },
      { name: 'BODEGA', activationCode: 'A2F-B109' },
    ],
  },
  {
    id: 50,
    name: 'DP World',
    subdomain: 'dpworld',
    departments: [
      { name: 'Default', activationCode: 'D32-D10D' },
      { name: 'Encargado', activationCode: 'D32-E10F' },
      { name: 'Gerente', activationCode: 'D32-G111' },
      { name: 'Administrativo', activationCode: 'D32-A10E' },
      { name: 'Estibador', activationCode: 'D32-E110' },
      { name: 'Jefe', activationCode: 'D32-J112' },
      { name: 'Movilizador', activationCode: 'D32-M115' },
      { name: 'Operador de Equipo', activationCode: 'D32-O116' },
      { name: 'Supervisor', activationCode: 'D32-S117' },
      { name: 'Mantención: Eléctrico', activationCode: 'D32-M113' },
      { name: 'Mantención: Mecánico', activationCode: 'D32-M114' },
    ],
  },
  {
    id: 55,
    name: 'Forvis Mazars',
    subdomain: 'forvismazars',
    departments: [
      { name: 'Audit', activationCode: 'F37-A12E' },
      { name: 'Tax & Legal', activationCode: 'F37-T12F' },
      { name: 'AOS', activationCode: 'F37-A130' },
      { name: 'FAS', activationCode: 'F37-F131' },
      { name: 'Servicios Generales', activationCode: 'F37-S132' },
      { name: 'Consultoría', activationCode: 'F37-C133' },
      { name: 'Otros', activationCode: 'F37-O134' },
    ],
  },
  {
    id: 65,
    name: 'Domino´s Pizza',
    subdomain: 'Dominos',
    departments: [],
  },
  {
    id: 61,
    name: 'MOWI Chonchi',
    subdomain: 'mowi',
    departments: [
      { name: 'ROC XR', activationCode: 'M3D-R175' },
      { name: 'ROC XIR', activationCode: 'M3D-R176' },
      { name: 'SSO', activationCode: 'M3D-S177' },
      { name: 'Operaciones', activationCode: 'M3D-O178' },
      { name: 'Sustentabilidad', activationCode: 'M3D-S179' },
      { name: 'Medio Ambiente', activationCode: 'M3D-M17A' },
      { name: 'Chinquihue', activationCode: 'M3D-C17B' },
      { name: 'Producción', activationCode: 'M3D-P180' },
      { name: 'Comunicaciones', activationCode: 'M3D-C181' },
    ],
  },
  {
    id: 60,
    name: 'Marsh',
    subdomain: 'marsh',
    departments: [{ name: 'Default', activationCode: 'M3C-D15A' }],
  },
  {
    id: 15,
    name: 'Sura',
    subdomain: 'sura',
    departments: [
      {
        name: 'GERENCIA REGIONAL SERVICIOS DE ASEGURAMIENTO',
        activationCode: 'SF-G4E',
      },
      { name: 'COMUNICACIONES Y CULTURA', activationCode: 'SF-C4F' },
      {
        name: 'DISEÑO ORGANIZACIONAL, COMPENSACIONES Y EXPERIENCIA DEL COLABORADOR',
        activationCode: 'SF-D50',
      },
      { name: 'OPERACIONES & CONTROL GESTION TH', activationCode: 'SF-O51' },
      { name: 'GERENCIA LEGAL', activationCode: 'SF-G52' },
      { name: 'PRESIDENCIA', activationCode: 'SF-P54' },
      {
        name: 'CAPACIDAD DE COMPETITIVIDAD EMPRESARIAL',
        activationCode: 'SF-C57',
      },
      { name: 'NEGOCIOS CORPORATIVOS', activationCode: 'SF-N59' },
      {
        name: 'GERENCIA DE NEGOCIOS EMPRESAS Y PERSONAS',
        activationCode: 'SF-G5A',
      },
      { name: 'MARKETING Y TRANSFORMACION DIGITAL', activationCode: 'SF-M5B' },
      { name: 'GERENCIA DE FINANZAS', activationCode: 'SF-G5C' },
      { name: '[CC] Otros', activationCode: 'SF-[4C' },
      { name: 'ADMINISTRACION', activationCode: 'SF-A56' },
      { name: 'VICEPRESIDENCIA DE SEGUROS', activationCode: 'SF-V55' },
      { name: 'RIESGOS FINANCIEROS', activationCode: 'SF-R58' },
      {
        name: 'PRESTACIONES MOVILIDAD AUTONOMIA Y SALUD',
        activationCode: 'SF-P53',
      },
      {
        name: 'GERENCIA DE NUEVOS MODELOS DE NEGOCIO Y DESARROLLO DE MERCADOS',
        activationCode: 'SF-G5E',
      },
      {
        name: 'GERENCIA DE SERVICIOS OPERACIONALES Y EXPERIENCIA DE CLIENTES',
        activationCode: 'SF-G5F',
      },
      { name: 'CONTROL GESTION', activationCode: 'SF-C61' },
      { name: '[CC] Dirección y Estrategia', activationCode: 'SF-[D8' },
      { name: '[CC] Negocios y Comercial', activationCode: 'SF-[DA' },
      { name: '[CC] Personas y Cultura', activationCode: 'SF-[DC' },
      { name: '[CC] Tecnología', activationCode: 'SF-[60' },
      { name: 'VICEPRESIDENCIA DE TALENTO HUMANO', activationCode: 'SF-V5D' },
      {
        name: 'VICEPRESIDENCIA DE FINANZAS Y GESTION DE INFORMACION',
        activationCode: 'SF-V63',
      },
      { name: 'PROYECTO CORE', activationCode: 'SF-P62' },
      { name: '[CC] Finanzas y Riesgo', activationCode: 'SF-[D9' },
      {
        name: '[CC] Operaciones y Servicio al cliente',
        activationCode: 'SF-[DB',
      },
    ],
  },
];

export const resolveBusinesses = (hostname: string): BusinessConfig[] => {
  const parts = hostname.split('.');
  const sub = parts[0];
  return businesses.filter(b => b.subdomain === sub);
};

export const resolveBusiness = (
  hostname: string
): BusinessConfig | undefined => {
  return resolveBusinesses(hostname)[0];
};
